var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricinfoPaymentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 30,
    viewBox: "0 0 90 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0241 9.14001C11.9386 7.36323 11.8359 5.21058 11.853 3.34838H11.8017C11.3399 5.02265 10.7755 6.88486 10.1598 8.62748L8.15859 14.607H6.19163L4.34441 8.7129C3.81418 6.9532 3.31817 5.07391 2.94188 3.34838H2.90767C2.85636 5.14224 2.77084 7.32906 2.66822 9.22543L2.36035 14.7779H0L0.923614 0.973633H4.24178L6.0548 6.52609C6.55082 8.14911 6.97842 9.78922 7.32049 11.3268H7.38891C7.7652 9.82339 8.227 8.13203 8.75723 6.509L10.6729 0.973633H13.9568L14.7607 14.7779H12.2806L12.0241 9.14001Z",
    fill: "url(#paint0_linear_4148_137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.107 10.4901C19.1754 12.301 20.5779 13.0698 22.1857 13.0698C23.3488 13.0698 24.2039 12.899 24.9565 12.6256L25.3328 14.3683C24.4776 14.71 23.2803 14.9833 21.8436 14.9833C18.611 14.9833 16.6953 13.0015 16.6953 9.94338C16.6953 7.1757 18.3715 4.57886 21.5699 4.57886C24.8026 4.57886 25.8801 7.24404 25.8801 9.43085C25.8801 9.90921 25.8459 10.268 25.7946 10.4901H19.107ZM23.5027 8.73039C23.5198 7.80782 23.1093 6.2873 21.4331 6.2873C19.8766 6.2873 19.2096 7.70532 19.107 8.73039H23.5027Z",
    fill: "#5F439B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.806 1.94727V4.80037H33.2005V6.67967H30.806V11.0875C30.806 12.3005 31.1309 12.9326 32.1059 12.9326C32.5335 12.9326 32.8584 12.8642 33.0979 12.813L33.1321 14.7435C32.7558 14.8802 32.1059 14.9827 31.302 14.9827C30.3784 14.9827 29.5916 14.6752 29.1298 14.1627C28.5995 13.5818 28.343 12.6934 28.343 11.3779V6.67967H26.9062V4.80037H28.343V2.54522L30.806 1.94727Z",
    fill: "#5F439B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1129 8.01284C35.1129 6.66316 35.0958 5.68935 35.0273 4.80096H37.2167L37.3022 6.71442H37.3877C37.8837 5.29641 39.0468 4.57886 40.1072 4.57886C40.3467 4.57886 40.5006 4.59594 40.7059 4.6472V7.00485C40.5006 6.97068 40.2783 6.91943 39.9704 6.91943C38.756 6.91943 37.935 7.70532 37.7127 8.83289C37.6785 9.05499 37.6271 9.32834 37.6271 9.61878V14.7783H35.1129V8.01284Z",
    fill: "#5F439B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.101 2.0158C45.101 2.76751 44.5537 3.36547 43.6642 3.36547C42.8262 3.36547 42.2617 2.76751 42.2617 2.0158C42.2617 1.22991 42.8262 0.649039 43.6814 0.649039C44.5537 0.631954 45.0839 1.22991 45.101 2.0158ZM42.4157 14.7779V4.80057H44.9641V14.7779H42.4157Z",
    fill: "#5F439B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0227 14.4708C54.4925 14.71 53.4491 14.9833 52.1834 14.9833C49.0705 14.9833 47.0352 13.0015 47.0352 9.90921C47.0352 6.91943 49.0876 4.57886 52.5939 4.57886C53.5176 4.57886 54.4583 4.78387 55.0398 5.05722L54.5951 6.93651C54.1846 6.74859 53.586 6.54357 52.6795 6.54357C50.7467 6.54357 49.6008 7.96158 49.6179 9.77254C49.6179 11.8227 50.952 12.9844 52.6795 12.9844C53.5689 12.9844 54.1846 12.7965 54.6635 12.5915L55.0227 14.4708Z",
    fill: "#5F439B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5197 0.956787V14.761H56.9883V0.956787H59.5197Z",
    fill: "url(#paint1_linear_4148_137)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4332 7.77365C62.4332 6.62899 62.4161 5.65518 62.3477 4.80096H64.5712L64.6909 6.30439H64.7593C65.1869 5.5185 66.2816 4.57886 67.9407 4.57886C69.6853 4.57886 71.4983 5.70643 71.4983 8.86706V14.7954H68.9669V9.1575C68.9669 7.7224 68.4367 6.62899 67.0512 6.62899C66.0421 6.62899 65.3408 7.34654 65.0843 8.09826C64.9988 8.32036 64.9817 8.62788 64.9817 8.91831V14.7783H62.4332V7.77365Z",
    fill: "url(#paint2_linear_4148_137)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4528 14.7781V6.68003H73.1016V4.80074H74.4528V4.35654C74.4528 3.05812 74.7949 1.77679 75.6672 0.956731C76.4026 0.273352 77.4118 0 78.2841 0C78.9682 0 79.4984 0.102507 79.9089 0.239183L79.7037 2.18681C79.43 2.08431 79.0879 1.99888 78.6432 1.99888C77.3947 2.01597 76.9671 3.05812 76.9671 4.2882V4.80074H79.1564V6.68003H76.9842V14.7781H74.4528Z",
    fill: "url(#paint3_linear_4148_137)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.002 9.68722C90.002 13.3604 87.4193 15.0005 84.8708 15.0005C82.0487 15.0005 79.8594 13.0529 79.8594 9.85806C79.8594 6.57784 82.0145 4.57896 85.0248 4.57896C88.0009 4.56188 90.002 6.66327 90.002 9.68722ZM82.4592 9.78973C82.4592 11.7203 83.3999 13.1725 84.9393 13.1725C86.376 13.1725 87.3851 11.7544 87.3851 9.75556C87.3851 8.20087 86.6839 6.407 84.9564 6.407C83.1775 6.407 82.4592 8.13253 82.4592 9.78973Z",
    fill: "url(#paint4_linear_4148_137)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1673 22.3359C45.1673 22.7263 45.0777 23.0847 44.8985 23.4111C44.7193 23.7311 44.4441 23.9903 44.0729 24.1887C43.7017 24.3871 43.2409 24.4863 42.6905 24.4863H41.6729V26.9055H40.0312V20.1663H42.6905C43.2281 20.1663 43.6825 20.2591 44.0537 20.4447C44.4249 20.6303 44.7033 20.8863 44.8889 21.2127C45.0745 21.5391 45.1673 21.9135 45.1673 22.3359ZM42.5657 23.1807C42.8793 23.1807 43.1129 23.1071 43.2665 22.9599C43.4201 22.8127 43.4969 22.6047 43.4969 22.3359C43.4969 22.0671 43.4201 21.8591 43.2665 21.7119C43.1129 21.5647 42.8793 21.4911 42.5657 21.4911H41.6729V23.1807H42.5657Z",
    fill: "#F38280"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6955 24.2175C45.6955 23.6671 45.7979 23.1839 46.0027 22.7679C46.2139 22.3519 46.4987 22.0319 46.8571 21.8079C47.2156 21.5839 47.6156 21.4719 48.0572 21.4719C48.4348 21.4719 48.7644 21.5487 49.046 21.7023C49.334 21.8559 49.5548 22.0575 49.7084 22.3071V21.5487H51.35V26.9055H49.7084V26.1471C49.5484 26.3967 49.3244 26.5983 49.0364 26.7519C48.7548 26.9055 48.4252 26.9823 48.0476 26.9823C47.6124 26.9823 47.2156 26.8703 46.8571 26.6463C46.4987 26.4159 46.2139 26.0927 46.0027 25.6767C45.7979 25.2543 45.6955 24.7679 45.6955 24.2175ZM49.7084 24.2271C49.7084 23.8175 49.5932 23.4943 49.3628 23.2575C49.1388 23.0207 48.8636 22.9023 48.5372 22.9023C48.2108 22.9023 47.9324 23.0207 47.702 23.2575C47.478 23.4879 47.366 23.8079 47.366 24.2175C47.366 24.6271 47.478 24.9535 47.702 25.1967C47.9324 25.4335 48.2108 25.5519 48.5372 25.5519C48.8636 25.5519 49.1388 25.4335 49.3628 25.1967C49.5932 24.9599 49.7084 24.6367 49.7084 24.2271Z",
    fill: "#F38280"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0097 21.5487L54.6497 29.4496H52.8832L54.1121 26.7231L51.9328 21.5487H53.7664L55.0049 24.8991L56.2337 21.5487H58.0097Z",
    fill: "#F38280"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4386 21.4911C66.1042 21.4911 66.6322 21.6927 67.0226 22.0959C67.4194 22.4991 67.6178 23.0591 67.6178 23.7759V26.9055H65.9858V23.9967C65.9858 23.6511 65.893 23.3855 65.7074 23.1999C65.5282 23.0079 65.2786 22.9119 64.9586 22.9119C64.6386 22.9119 64.3858 23.0079 64.2002 23.1999C64.021 23.3855 63.9314 23.6511 63.9314 23.9967V26.9055H62.2994V23.9967C62.2994 23.6511 62.2066 23.3855 62.021 23.1999C61.8418 23.0079 61.5922 22.9119 61.2722 22.9119C60.9522 22.9119 60.6993 23.0079 60.5137 23.1999C60.3345 23.3855 60.2449 23.6511 60.2449 23.9967V26.9055H58.6033V21.5487H60.2449V22.2207C60.4113 21.9967 60.6289 21.8207 60.8978 21.6927C61.1666 21.5583 61.4706 21.4911 61.8098 21.4911C62.213 21.4911 62.5714 21.5775 62.885 21.7503C63.205 21.9231 63.4546 22.1695 63.6338 22.4895C63.8194 22.1951 64.0722 21.9551 64.3922 21.7695C64.7122 21.5839 65.061 21.4911 65.4386 21.4911Z",
    fill: "#F38280"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8156 24.1407C73.8156 24.2943 73.806 24.4543 73.7868 24.6207H70.0715C70.0971 24.9535 70.2027 25.2095 70.3884 25.3887C70.5804 25.5615 70.814 25.6479 71.0892 25.6479C71.4988 25.6479 71.7836 25.4751 71.9436 25.1295H73.6908C73.6012 25.4815 73.438 25.7983 73.2012 26.0799C72.9708 26.3615 72.6796 26.5823 72.3276 26.7423C71.9756 26.9023 71.582 26.9823 71.1468 26.9823C70.622 26.9823 70.1547 26.8703 69.7451 26.6463C69.3355 26.4223 69.0155 26.1023 68.7851 25.6863C68.5547 25.2703 68.4395 24.7839 68.4395 24.2271C68.4395 23.6703 68.5515 23.1839 68.7755 22.7679C69.0059 22.3519 69.3259 22.0319 69.7355 21.8079C70.1452 21.5839 70.6156 21.4719 71.1468 21.4719C71.6652 21.4719 72.126 21.5807 72.5292 21.7983C72.9324 22.0159 73.246 22.3263 73.47 22.7295C73.7004 23.1327 73.8156 23.6031 73.8156 24.1407ZM72.1356 23.7087C72.1356 23.4271 72.0396 23.2031 71.8476 23.0367C71.6556 22.8703 71.4156 22.7871 71.1276 22.7871C70.8524 22.7871 70.6188 22.8671 70.4268 23.0271C70.2412 23.1871 70.1259 23.4143 70.0811 23.7087H72.1356Z",
    fill: "#F38280"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9457 21.4911C78.5729 21.4911 79.0721 21.6959 79.4433 22.1055C79.8209 22.5087 80.0097 23.0655 80.0097 23.7759V26.9055H78.3777V23.9967C78.3777 23.6383 78.2849 23.3599 78.0993 23.1615C77.9137 22.9631 77.6641 22.8639 77.3505 22.8639C77.0368 22.8639 76.7872 22.9631 76.6016 23.1615C76.416 23.3599 76.3232 23.6383 76.3232 23.9967V26.9055H74.6816V21.5487H76.3232V22.2591C76.4896 22.0223 76.7136 21.8367 76.9952 21.7023C77.2769 21.5615 77.5937 21.4911 77.9457 21.4911Z",
    fill: "#F38280"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1361 25.5135V26.9055H83.3009C82.7057 26.9055 82.2417 26.7615 81.9089 26.4735C81.576 26.1791 81.4096 25.7023 81.4096 25.0431V22.9119H80.7568V21.5487H81.4096V20.2431H83.0513V21.5487H84.1265V22.9119H83.0513V25.0623C83.0513 25.2223 83.0897 25.3375 83.1665 25.4079C83.2433 25.4783 83.3713 25.5135 83.5505 25.5135H84.1361Z",
    fill: "#F38280"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2297 26.9823C86.7625 26.9823 86.3465 26.9023 85.9817 26.7423C85.6169 26.5823 85.3289 26.3647 85.1177 26.0895C84.9065 25.8079 84.7881 25.4943 84.7625 25.1487H86.3849C86.4041 25.3343 86.4905 25.4847 86.6441 25.5999C86.7977 25.7151 86.9865 25.7727 87.2105 25.7727C87.4153 25.7727 87.5721 25.7343 87.6809 25.6575C87.7961 25.5743 87.8537 25.4687 87.8537 25.3407C87.8537 25.1871 87.7737 25.0751 87.6137 25.0047C87.4537 24.9279 87.1945 24.8447 86.8361 24.7551C86.4521 24.6655 86.1321 24.5727 85.8761 24.4767C85.6201 24.3743 85.3993 24.2175 85.2137 24.0063C85.0281 23.7887 84.9353 23.4975 84.9353 23.1327C84.9353 22.8255 85.0185 22.5471 85.1849 22.2975C85.3577 22.0415 85.6073 21.8399 85.9337 21.6927C86.2665 21.5455 86.6601 21.4719 87.1145 21.4719C87.7865 21.4719 88.3145 21.6383 88.6985 21.9711C89.0889 22.3039 89.3129 22.7455 89.3705 23.2959H87.8537C87.8281 23.1103 87.7449 22.9631 87.6041 22.8543C87.4697 22.7455 87.2905 22.6911 87.0665 22.6911C86.8745 22.6911 86.7273 22.7295 86.6249 22.8063C86.5225 22.8767 86.4713 22.9759 86.4713 23.1039C86.4713 23.2575 86.5513 23.3727 86.7113 23.4495C86.8777 23.5263 87.1337 23.6031 87.4793 23.6799C87.8761 23.7823 88.1993 23.8847 88.4489 23.9871C88.6985 24.0831 88.9161 24.2431 89.1017 24.4671C89.2937 24.6847 89.3929 24.9791 89.3993 25.3503C89.3993 25.6639 89.3097 25.9455 89.1305 26.1951C88.9577 26.4383 88.7049 26.6303 88.3721 26.7711C88.0457 26.9119 87.6649 26.9823 87.2297 26.9823Z",
    fill: "#F38280"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4148_137",
    x1: -0.280163,
    y1: 7.86807,
    x2: 88.7861,
    y2: 7.86807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4148_137",
    x1: -0.282251,
    y1: 7.86831,
    x2: 88.784,
    y2: 7.86831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4148_137",
    x1: -0.276425,
    y1: 9.67191,
    x2: 88.7899,
    y2: 9.67191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4148_137",
    x1: -0.280905,
    y1: 7.38682,
    x2: 88.7854,
    y2: 7.38682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4148_137",
    x1: -0.279165,
    y1: 9.78477,
    x2: 88.7871,
    y2: 9.78477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricinfoPaymentLogo);
export default __webpack_public_path__ + "static/media/metricinfo-payment-logo.78674972e41ad974c5204c4b516ea34f.svg";
export { ForwardRef as ReactComponent };